<template>
  <PreviewBase
    v-if="type === 'acknowledgement'"
    :loading="loading"
  >
    <template #loading>
      <AcknowledgementPreviewSkeleton />
    </template>

    <div
      v-if="acknowledgement"
      class="d-flex flex-column ga-4"
    >
      <div class="d-flex flex-column ga-1 text-center">
        <div class="text-body-1 text-textDarkest">
          {{ acknowledgement.title }}
        </div>

        <div class="text-body-2 text-textLight">
          {{ acknowledgement.status }}
        </div>

        <div
          v-if="acknowledgement.employee"
          class="text-body-2 text-textLight"
        >
          Assigned to
          <span class="text-textDarkest">
            {{ acknowledgement.employee.first_name }}
            {{ acknowledgement.employee.last_name }}
          </span>
        </div>
      </div>

      <div class="d-flex flex-column ga-2">
        <div
          v-for="(field, i) in fieldHtml"
          :key="field.id"
        >
          <v-divider
            v-if="i > 0"
            class="opacity-100 mt-3 mb-4"
          />

          <div class="mb-2 text-body-1 text-textDarkest">
            {{ field.label }}
          </div>

          <DocumentPreviewFieldHtml
            class="d-flex flex-column ga-2"
            :html="field.html"
          />
        </div>
      </div>
    </div>
  </PreviewBase>
</template>

<script setup>
import { computed, ref, watch } from 'vue';
import { useRoute } from 'vue-router';
import { useAppSnackbar } from '@/stores/app/snackbar';
import DocumentPreviewFieldHtml from '@ui/components/general/DocumentPreviewFieldHtml/DocumentPreviewFieldHtml.vue';
import PreviewBase from '@/components/shared/PreviewBase.vue';
import AcknowledgementPreviewSkeleton from '@/components/jobProfiles/AcknowledgementPreviewSkeleton.vue';
import { getAcknowledgement } from '@/api/jobProfile';
import { useTracking } from '@/stores/tracking/tracking';

const route = useRoute();
const { addErrorSnackbar } = useAppSnackbar();

const id = computed(() => route.query?.preview);
const type = computed(() => route.query?.type || '');

const loading = ref(false);
const acknowledgement = ref(null);

const fieldHtml = computed(() => acknowledgement.value?.fields
  .map((f) => ({
    ...f,
    html: f.blocks.reduce((res, block) => res + (block.html || ''), ''),
  })));

const load = async () => {
  try {
    loading.value = true;
    acknowledgement.value = await getAcknowledgement({ ulid: id.value, mode: 'pending' });
  } catch (e) {
    addErrorSnackbar({ text: `Load error - ${e.message}` });
    throw e;
  } finally {
    loading.value = false;
  }
};

watch(id, () => {
  if (id.value && type.value === 'acknowledgement') {
    useTracking().ackLibOpenedAcknowledgementPreview();
    load();
  }
}, { immediate: true });
</script>
